import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import useInactivityTimer from '../../hooks/useInactivityTimer';
import InactivityTimer from '../../components/InactivityTimer';
import InactivityWarning from '../../components/InactivityWarning';
import { walletAPI } from '../../services/api';

import WalletToWalletTransferModal from '../../components/WalletToWalletTransferModal';
import CreateRetailerModal from '../../components/CreateRetailerModal';
import WithdrawMoneyModal from '../../components/WithdrawMoneyModal';
import CommissionSummaryModal from '../../components/CommissionSummaryModal';
// User-only service modals removed - these services are not available to distributors
// import MobileRechargeModal from '../../components/MobileRechargeModal';
// import BillPaymentModal from '../../components/BillPaymentModal';
// import CreditCardPaymentModal from '../../components/CreditCardPaymentModal';
// import InsuranceModal from '../../components/InsuranceModal';
// import CMSModal from '../../components/CMSModal';
// import PPIDMTModal from '../../components/PPIDMTModal';
// import FinoDMTModal from '../../components/FinoDMTModal';
// import AEPSModal from '../../components/AEPSModal';
// import MicroATMModal from '../../components/MicroATMModal';
// import AEPSCashDepositModal from '../../components/AEPSCashDepositModal';
// import AccountOpeningModal from '../../components/AccountOpeningModal';
import VerificationsModal from '../../components/VerificationsModal';
// import BusBookingModal from '../../components/BusBookingModal'; // Removed
import KycUploadModal from '../../components/KycUploadModal';
import {
  FaUserCircle, FaBell, FaMoneyBillWave, FaExchangeAlt, FaCreditCard, FaFileAlt, FaChartLine, FaHistory, FaHeadset,
  FaMobile, FaFileInvoiceDollar, FaShieldAlt, FaBusinessTime, FaUsers, FaCoins, FaCheckCircle, FaBus, FaUserPlus,
  FaUniversity, FaPlusCircle, FaMinusCircle, FaClock, FaChartBar, FaIdCard
} from 'react-icons/fa';

const sidebarSections = [
  {
    title: 'Navigation',
    items: [
      { label: 'Dashboard' },
      { label: 'Business Summary' },
    ],
  },
  {
    title: 'Outlet Management',
    items: [
      { label: 'Retailers' },
      { label: 'Manage Balance' },
      { label: 'Transactions' },
      { label: 'Commission' },
    ],
  },
  {
    title: 'My Section',
    items: [
      { label: 'Investments' },
      { label: 'Money Request' },
      { label: 'Complaints' },
    ],
  },
  {
    title: 'Configuration',
    items: [
      { label: 'Previous Reports' },
      { label: 'Settings' },
    ],
  },
];

const actionTiles = [
  // Note: User-only services (PPI DMT, Fino DMT, AEPS, Micro ATM, AEPS Cash Deposit, 
  // Account Opening, Mobile Recharge, Bill Payment, Credit Card Payment, Insurance, 
  // CMS, Leads Generation, Digital Gold) are restricted to users only and not available to distributors
  
  // Digital Services (Available to Distributors)
  { label: 'Verifications', icon: <FaCheckCircle className="mx-auto text-green-700 text-2xl sm:text-3xl" />, category: 'digital' },
  { label: 'KYC Upload', icon: <FaIdCard className="mx-auto text-indigo-600 text-2xl sm:text-3xl" />, category: 'digital' },
  
  // Travel Services - Removed
  // { label: 'Bus Booking', icon: <FaBus className="mx-auto text-blue-500 text-2xl sm:text-3xl" />, category: 'travel' },
  
  // Management Options (Available to Distributors)
  { label: 'Create Retailer', icon: <FaUserPlus className="mx-auto text-blue-600 text-2xl sm:text-3xl" />, category: 'management' },
  { label: 'Credit Money', icon: <FaPlusCircle className="mx-auto text-green-600 text-2xl sm:text-3xl" />, category: 'management' },
  { label: 'Withdraw Money', icon: <FaMinusCircle className="mx-auto text-red-600 text-2xl sm:text-3xl" />, category: 'management' },
  { label: 'Wallet To Wallet', icon: <FaExchangeAlt className="mx-auto text-purple-600 text-2xl sm:text-3xl" />, category: 'management' },

  { label: 'Virtual Transactions', icon: <FaCreditCard className="mx-auto text-blue-600 text-2xl sm:text-3xl" />, category: 'management' },
  { label: 'Pending Requests', icon: <FaClock className="mx-auto text-orange-600 text-2xl sm:text-3xl" />, category: 'management' },
  { label: 'Commission Summary', icon: <FaChartBar className="mx-auto text-purple-600 text-2xl sm:text-3xl" />, category: 'management' }
];

const statCards = [
  { label: 'Total Transactions', value: 0, color: 'bg-purple-600' },
  { label: 'Total Amount', value: 0, color: 'bg-cyan-600' },
  { label: 'Commission Earned', value: 0, color: 'bg-green-600' },
  { label: 'Commission Credited', value: 0, color: 'bg-blue-600' },
  { label: 'Commission Pending', value: 0, color: 'bg-red-600' },
  { label: 'Commission Settled', value: 0, color: 'bg-sky-600' },
  { label: 'Available Commission', value: 115.69, color: 'bg-green-700' },
];

const quickStats = [
  { label: 'Fund', value: 0 },
  { label: 'Money Transfer', value: 0 },
  { label: 'Utilities Paid', value: 0 },
  { label: 'AEPS/MATM', value: 0 },
  { label: 'Credit Card', value: 0 },
  { label: 'Aadhar Pay', value: 0 },
];
const inProgressStats = [
  { label: 'Money Transfer', value: 0 },
  { label: 'Recharges/Utility', value: 0 },
  { label: 'Credit Card', value: 0 },
  { label: 'AEPS/MATM', value: 0 },
  { label: 'Aadhar Pay', value: 0 },
];
const refundStats = [
  { label: 'Money Transfer', value: 2 },
  { label: 'Utilities', value: 0 },
  { label: 'Credit Card', value: 0 },
];

export default function DistributorDashboard() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const distributor = {
    name: 'BIPIN TELECOM',
    code: 'SPD02169',
    phone: '9910997007',
    openingBalance: 0.12,
    availableBalance: 0.12,
    creditBalance: 0,
    holdBalance: 0,
    notifications: 0,
    profileImg: '',
  };
  const year = new Date().getFullYear();
  const [availableBalance, setAvailableBalance] = useState(0);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [lastLogin, setLastLogin] = useState(null);

  const [showWalletToWalletModal, setShowWalletToWalletModal] = useState(false);
  const [showDMTModal] = useState(false);
  const [showCreateRetailerModal, setShowCreateRetailerModal] = useState(false);
  const [showWithdrawModal, setShowWithdrawModal] = useState(false);
  const [showCommissionModal, setShowCommissionModal] = useState(false);
  // User-only service modals removed - these services are not available to distributors
  // const [showMobileRechargeModal, setShowMobileRechargeModal] = useState(false);
  // const [showBillPaymentModal, setShowBillPaymentModal] = useState(false);
  // const [showCreditCardModal, setShowCreditCardModal] = useState(false);
  // const [showInsuranceModal, setShowInsuranceModal] = useState(false);
  // const [showCMSModal, setShowCMSModal] = useState(false);
  // const [showPPIDMTModal, setShowPPIDMTModal] = useState(false);
  // const [showFinoDMTModal, setShowFinoDMTModal] = useState(false);
  // const [showAEPSModal, setShowAEPSModal] = useState(false);
  // const [showMicroATMModal, setShowMicroATMModal] = useState(false);
  // const [showAEPSCashDepositModal, setShowAEPSCashDepositModal] = useState(false);
  // const [showAccountOpeningModal, setShowAccountOpeningModal] = useState(false);
  const [showVerificationsModal, setShowVerificationsModal] = useState(false);
  // const [showBusBookingModal, setShowBusBookingModal] = useState(false); // Removed
  const [showKycUploadModal, setShowKycUploadModal] = useState(false);
  const [settingsImages, setSettingsImages] = useState({ logo: '', banner: '' });
  const [currentView, setCurrentView] = useState('dashboard');
  const [logoLoaded, setLogoLoaded] = useState(false);
  const [currentTime, setCurrentTime] = useState(new Date());

  // Inactivity timer
  const {
    timeLeft,
    showWarning,
    formatTime,
    handleContinue,
    handleLogout,
    setIsActive
  } = useInactivityTimer(logout, 240000); // 4 minutes

  const updateBalance = (newBalance) => {
    setAvailableBalance(newBalance);
  };

  // Function to refresh balance from API
  const refreshBalance = async () => {
    try {
      const response = await walletAPI.getUserWallet();
      if (response.data && response.data.balance !== undefined) {
        setAvailableBalance(response.data.balance);
      }
    } catch (error) {
      console.error('Error refreshing balance:', error);
    }
  };

    const handleActionTileClick = (tileLabel) => {
    switch (tileLabel) {
      // User-only services removed - these are not available to distributors
      // PPI DMT, Fino DMT, AEPS, Micro ATM, AEPS Cash Deposit, Account Opening,
      // Mobile Recharge, Bill Payment, Credit Card Payment, Insurance, CMS, 
      // Leads Generation, Digital Gold are restricted to users only
      case 'Verifications':
        setShowVerificationsModal(true);
        break;
      case 'KYC Upload':
        setShowKycUploadModal(true);
        break;
      
      // Travel Services - Removed
      // case 'Bus Booking':
      //   setShowBusBookingModal(true);
      //   break;
      
      // Management Options
      case 'Create Retailer':
        setShowCreateRetailerModal(true);
        break;
      case 'Credit Money':
        // Add Money functionality removed
        break;
      case 'Withdraw Money':
        setShowWithdrawModal(true);
        break;
      case 'Wallet To Wallet':
        setShowWalletToWalletModal(true);
        break;

      case 'Virtual Transactions':
        setCurrentView('virtual-transactions');
        break;
      case 'Pending Requests':
        setCurrentView('pending-requests');
        break;
      case 'Commission Summary':
        setShowCommissionModal(true);
        break;
      
      default:
        console.log(`Action for ${tileLabel} not implemented yet`);
    }
  };

  useEffect(() => {
    const fetchBalance = async () => {
      try {
        const response = await walletAPI.getUserWallet();
        console.log('Distributor balance response:', response.data);
        // The existing route returns { balance: number }
        if (response.data && response.data.balance !== undefined) {
          setAvailableBalance(response.data.balance);
        } else {
          setAvailableBalance(0);
        }
      } catch (error) {
        console.error('Error fetching distributor balance:', error);
        setAvailableBalance(0);
      }
    };

    fetchBalance();
  }, []);

  useEffect(() => {
    const fetchLastLogin = async () => {
      try {
        const response = await walletAPI.get('/api/login-logs/last-login');
        if (response.data.success && response.data.data) {
          setLastLogin(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching last login:', error);
      }
    };
    fetchLastLogin();
  }, []);

  useEffect(() => {
    const fetchSettingsImages = async () => {
      try {
        const res = await walletAPI.getSettingsImages();
        console.log('Settings API response:', res.data);
        setSettingsImages(res.data);
      } catch (e) {
        console.log('Settings API error:', e);
      }
    };
    fetchSettingsImages();
  }, []);

  // Update time every minute to refresh greeting
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000); // Update every minute

    return () => clearInterval(timer);
  }, []);

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000';
  const getImageUrl = (url) => {
    if (!url) return '';
    if (url.startsWith('http')) return url;
    return `${API_BASE_URL}${url}`;
  };

  // Helper function to get logo URL with fallback
  const getLogoUrl = () => {
    // For now, always use the fallback logo to prevent flickering
    // TODO: Debug API logo loading issue separately
    console.log('Using fallback logo URL: /bt-india-logo.jpeg');
    return '/bt-india-logo.jpeg';
  };

  // Helper function to get time-based greeting
  const getTimeBasedGreeting = () => {
    const hour = currentTime.getHours();
    console.log('Current time:', currentTime.toLocaleString(), 'Hour:', hour);
    
    if (hour < 12) {
      return 'Good Morning';
    } else if (hour < 17) {
      return 'Good Afternoon';
    } else {
      return 'Good Evening';
    }
  };

  return (
    <div className="min-h-screen h-screen flex flex-col bg-gray-100">
      {/* Header */}
      <header className="bg-gradient-to-r from-indigo-900 via-blue-900 to-blue-700 text-white px-4 sm:px-6 py-3">
        {/* Mobile Header */}
        <div className="flex items-center justify-between lg:hidden">
          <div className="flex items-center gap-2">
            <img 
              src={getLogoUrl()} 
              alt="BT India Logo" 
              className="h-8 w-auto" 
            />
            <h1 className="text-lg font-bold">Dashboard</h1>
          </div>
          <div className="flex items-center gap-2">
            <FaBell className="text-lg" />
            <button onClick={logout} className="px-3 py-1 bg-blue-800 hover:bg-blue-900 rounded text-white text-sm">Logout</button>
          </div>
        </div>

        {/* Desktop Header */}
        <div className="hidden lg:flex items-center justify-between">
          <div className="flex items-center gap-4">
            <img 
              src={getLogoUrl()} 
              alt="BT India Logo" 
              className="h-16 w-auto" 
            />
            <div>
              <h1 className="text-2xl font-bold tracking-wide">Distributor Dashboard</h1>
            </div>
            <InactivityTimer 
              timeLeft={timeLeft} 
              formatTime={formatTime} 
              isActive={!!user} 
            />
          </div>
          <div className="flex-1 flex justify-center space-x-8 text-xs md:text-base">
            <div className="flex flex-col items-center"><span className="text-blue-200">Opening Balance</span><span className="text-blue-400">0</span></div>
            <div className="flex flex-col items-center"><span className="text-green-200">Available Balance</span><span className="text-green-400">{availableBalance}</span></div>
            <div className="flex flex-col items-center"><span className="text-red-200">Credit Balance</span><span className="text-red-400">0</span></div>
            <div className="flex flex-col items-center"><span className="text-yellow-200">Hold Balance</span><span className="text-yellow-400">0</span></div>
            {/* Wallet Buttons for user and distributor */}
            {(user?.role === 'user' || user?.role === 'distributor') && (
              <>
                <button
                  className="ml-4 bg-yellow-400 hover:bg-yellow-500 text-blue-900 font-semibold px-4 py-2 rounded shadow transition"
                  onClick={() => navigate('/wallet/update-payment')}
                >
                  Update Payment
                </button>
                <button
                  className="ml-2 bg-green-400 hover:bg-green-500 text-blue-900 font-semibold px-4 py-2 rounded shadow transition"
                  onClick={() => navigate('/wallet/my-requests')}
                >
                  My Requests
                </button>
              </>
            )}
          </div>
          <div className="flex items-center gap-4">
            <FaBell className="text-xl" />
            <span className="font-semibold">{user?.email || user?.username || 'User'}</span>
            <FaUserCircle className="text-2xl" />
            <button onClick={logout} className="ml-4 px-4 py-2 bg-blue-800 hover:bg-blue-900 rounded text-white font-semibold text-sm shadow">Logout</button>
          </div>
        </div>

        {/* Mobile Balance Bar */}
        <div className="lg:hidden mt-3 bg-blue-800 rounded-lg p-3">
          <div className="grid grid-cols-2 gap-2 text-xs">
            <div className="flex flex-col items-center"><span className="text-blue-200">Available</span><span className="text-green-400 font-bold">{availableBalance}</span></div>
            <div className="flex flex-col items-center"><span className="text-blue-200">Credit</span><span className="text-red-400 font-bold">0</span></div>
          </div>
          {(user?.role === 'user' || user?.role === 'distributor') && (
            <div className="space-y-2 mt-2">
              <button
                className="w-full bg-yellow-400 hover:bg-yellow-500 text-blue-900 font-semibold px-4 py-2 rounded shadow transition"
                onClick={() => navigate('/wallet/update-payment')}
              >
                Update Payment
              </button>
              <button
                className="w-full bg-green-400 hover:bg-green-500 text-blue-900 font-semibold px-4 py-2 rounded shadow transition"
                onClick={() => navigate('/wallet/my-requests')}
              >
                My Requests
              </button>
            </div>
          )}
        </div>
      </header>

      <div className="flex flex-1 min-h-0">
        {/* Mobile Menu Button */}
        <button 
          className="lg:hidden fixed top-4 left-4 z-50 bg-blue-900 text-white p-2 rounded-lg shadow-lg"
          onClick={() => setShowMobileMenu(!showMobileMenu)}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        {/* Mobile Menu Overlay */}
        {showMobileMenu && (
          <div 
            className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
            onClick={() => setShowMobileMenu(false)}
          />
        )}

        {/* Sidebar */}
        <aside className={`w-64 bg-gradient-to-b from-indigo-900 to-blue-900 text-white flex flex-col justify-between p-4 min-h-0 fixed lg:relative inset-y-0 left-0 z-50 transform transition-transform duration-300 ease-in-out ${showMobileMenu ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`}>
          <div>
            {sidebarSections.map((section, idx) => (
              <div key={idx} className="mb-4">
                <div className="uppercase text-xs text-blue-200 font-bold mb-2">{section.title}</div>
                <ul className="space-y-1 text-sm">
                  {section.items.map((item, i) => (
                    <li
                      key={i}
                      className="p-2 rounded hover:bg-blue-800 cursor-pointer flex items-center"
                      onClick={undefined}
                    >
                      <span className="ml-2">{item.label}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
            <div className="mt-8 text-center">
              <div className="text-pink-400 font-bold text-lg mb-2">Let's CONNECT</div>
              <div className="bg-blue-800 rounded-lg p-3 mb-2">
                <div className="flex items-center justify-center mb-2">
                  <FaUserCircle className="text-3xl mr-2" />
                  <div>
                    <div className="font-semibold">{distributor.name}</div>
                    <div className="text-xs">Distributor - {distributor.code}</div>
                  </div>
                </div>
                <div className="text-xs">Phone: {distributor.phone}</div>
              </div>
              <div className="bg-blue-800 rounded-lg p-3 text-xs">
                <div className="font-semibold mb-1">QUICK SUPPORT :</div>
                <div className="mb-1">Phone: 011-40004000</div>
                <div className="mb-1">Email: info@btindia.com</div>
              </div>
            </div>
          </div>
          <footer className="text-center text-xs text-blue-200 mt-8">© {year} BT India. All rights reserved.</footer>
        </aside>

        {/* Main Content */}
        <main className="flex-1 p-2 sm:p-4 min-h-0 overflow-auto bg-gray-50 lg:ml-0">
          {/* Notification Bar */}
          <div className="bg-white rounded shadow flex items-center px-4 py-2 mb-4">
            <FaBell className="text-red-500 mr-2" />
            <span className="text-red-600 font-semibold">You have 0 New Notifications !</span>
          </div>

          {/* Greeting */}
          <div className="flex justify-between items-center mb-4">
            <div className="text-xl font-semibold text-blue-900">Hey ! {getTimeBasedGreeting()} , Hope You are doing Good !!!</div>
            {lastLogin && (
              <div className="text-sm text-gray-600">
                <FaClock className="inline mr-1" />
                Last Login: {lastLogin.time_ago || lastLogin.formatted_date || 'N/A'}
              </div>
            )}
          </div>

          {/* Stat Cards */}
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-4 mb-6">
            {statCards.map((card, idx) => (
              <div key={idx} className={`rounded-lg shadow p-4 flex flex-col items-center text-white ${card.color}`}>
                <span className="text-2xl font-bold">{card.value}</span>
                <span className="text-xs mt-1 text-white/80 text-center">{card.label}</span>
              </div>
            ))}
          </div>

          {/* Action Tiles */}
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 gap-2 sm:gap-3 mb-6">
            {actionTiles.map((tile, idx) => (
              <div
                key={idx}
                className="bg-white rounded-lg shadow p-2 sm:p-4 flex flex-col items-center hover:bg-blue-50 cursor-pointer transition transform hover:scale-105 min-h-[80px] sm:min-h-[100px]"
                onClick={() => handleActionTileClick(tile.label)}
              >
                {tile.icon}
                <span className="mt-2 text-xs text-center font-medium text-gray-700">{tile.label}</span>
              </div>
            ))}
          </div>

          {/* Quick Stats, InProgress, Refund Pending */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-6">
            {/* Quick Stats */}
            <div className="bg-white rounded-xl shadow p-4">
              <h3 className="font-semibold mb-2 text-blue-900">Quick Stats</h3>
              <div className="grid grid-cols-2 gap-2 text-xs">
                {quickStats.map((stat, idx) => (
                  <div key={idx} className="bg-blue-50 rounded p-2 flex flex-col items-center">
                    <span className="font-bold text-lg text-blue-700">{stat.value}</span>
                    <span className="text-gray-600">{stat.label}</span>
                  </div>
                ))}
              </div>
            </div>
            {/* InProgress Transactions */}
            <div className="bg-white rounded-xl shadow p-4">
              <h3 className="font-semibold mb-2 text-blue-900">InProgress Transactions</h3>
              <div className="grid grid-cols-2 gap-2 text-xs">
                {inProgressStats.map((stat, idx) => (
                  <div key={idx} className="bg-purple-50 rounded p-2 flex flex-col items-center">
                    <span className="font-bold text-lg text-purple-700">{stat.value}</span>
                    <span className="text-gray-600">{stat.label}</span>
                  </div>
                ))}
              </div>
            </div>
            {/* Refund Pending Transactions */}
            <div className="bg-white rounded-xl shadow p-4">
              <h3 className="font-semibold mb-2 text-blue-900">Refund Pending Transactions</h3>
              <div className="grid grid-cols-3 gap-2 text-xs">
                {refundStats.map((stat, idx) => (
                  <div key={idx} className="bg-red-50 rounded p-2 flex flex-col items-center">
                    <span className="font-bold text-lg text-red-700">{stat.value}</span>
                    <span className="text-gray-600">{stat.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Banners/Ads */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="bg-white rounded-xl shadow p-4 flex items-center justify-center h-32">
              <img src={getImageUrl(settingsImages.banner)} alt="BT India Banner" className="h-full object-contain" />
            </div>
            <div className="bg-white rounded-xl shadow p-4 flex items-center justify-center h-32">
              <span className="text-gray-500 text-center">(Ad/Info Banner)</span>
            </div>
          </div>
        </main>
      </div>
      {/* Modals */}

      
      <WalletToWalletTransferModal 
        show={showWalletToWalletModal} 
        onHide={() => setShowWalletToWalletModal(false)} 
        onSuccess={(data) => {
          console.log('Transfer successful:', data);
          // Refresh balance after successful transaction
          refreshBalance();
        }}
        onBalanceUpdate={updateBalance}
      />
      
      
      <CreateRetailerModal
        show={showCreateRetailerModal}
        onHide={() => setShowCreateRetailerModal(false)}
        onSuccess={(data) => {
          console.log('Retailer created successfully:', data);
          alert(`Retailer "${data.name}" has been created successfully!`);
        }}
      />
      
      <WithdrawMoneyModal
        show={showWithdrawModal}
        onHide={() => setShowWithdrawModal(false)}
        availableBalance={availableBalance}
        onSuccess={(data) => {
          console.log('Withdrawal requested:', data);
          // Refresh balance after withdrawal request
          refreshBalance();
          alert(`Withdrawal request of ₹${data.amount} has been submitted successfully!`);
        }}
      />
      
      <CommissionSummaryModal
        show={showCommissionModal}
        onHide={() => setShowCommissionModal(false)}
      />

        {/* User-only service modals removed - these services are not available to distributors:
            MobileRechargeModal, BillPaymentModal, CreditCardPaymentModal, InsuranceModal, 
            CMSModal, PPIDMTModal, FinoDMTModal, AEPSModal, MicroATMModal, 
            AEPSCashDepositModal, AccountOpeningModal */}

        <VerificationsModal
          show={showVerificationsModal}
          onHide={() => setShowVerificationsModal(false)}
          onSuccess={(data) => {
            console.log('Verification completed:', data);
            alert(`Verification completed! Reference: ${data.reference}`);
          }}
        />

        {/* BusBookingModal removed */}

        <KycUploadModal
          show={showKycUploadModal}
          onHide={() => setShowKycUploadModal(false)}
          onSuccess={(data) => {
            console.log('KYC document uploaded:', data);
            alert(`KYC document uploaded successfully!`);
          }}
        />

        {/* Inactivity Warning Popup */}
        <InactivityWarning 
          showWarning={showWarning}
          handleContinue={handleContinue}
          handleLogout={handleLogout}
        />
    </div>
  );
} 